module.exports = {
  // debug: process.env.NODE_ENV === 'development',
  i18n: {
    locales: ['en', 'hr'],
    defaultLocale: 'en',
    localeDetection: false,
  },
};
